import { keys } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getStringProp } from '@mews/fp';
import { MODULE_NAME } from './constants';

const moduleSelector = (state: $TSFixMe) => state[MODULE_NAME];

const getSubscriptionCountMap = createSelector(moduleSelector, (data) => data.subscriptions);

export const isSubscriptionTypeSubscribed = createSelector(
    getSubscriptionCountMap,
    getStringProp('subscriptionType'),
    (countMap, subscriptionType) => countMap[subscriptionType] > 0
);
export const getSubscriptions = createSelector(getSubscriptionCountMap, keys);
